const getMemberships = () => {};

export default getMemberships;
